// Copied from https://github.com/kennethjiang/js-file-download/blob/master/file-download.js
export function downloadFile(data, filename = 'download.pdf', headers, mime, bom) {
  if (!window) return;

  if (headers) {
    const contentDisposition = headers['content-disposition'];
    if (contentDisposition) {
      const fnameCandidate = contentDisposition.split('filename=')[1].replace(/['"]/g, '');
      if (fnameCandidate) filename = fnameCandidate;
    }
  }

  const navigatorExt = window.navigator;

  // Ensure UTF-8 encoding with BOM for text files
  const isTextFile = mime && mime.startsWith('text/');
  const utf8BOM = new Uint8Array([0xef, 0xbb, 0xbf]); // UTF-8 BOM
  const blobData = isTextFile ? [utf8BOM, data] : [data]; // Prepend BOM if text file
  const blob = new Blob(blobData, {
    type: (mime || 'application/octet-stream') + (isTextFile ? ';charset=utf-8' : ''),
  });

  if (typeof navigatorExt.msSaveBlob !== 'undefined') {
    navigatorExt.msSaveBlob(blob, filename);
  } else {
    const blobURL =
      window.URL && window.URL.createObjectURL
        ? window.URL.createObjectURL(blob)
        : window.webkitURL.createObjectURL(blob);
    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute('download', filename);

    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }

    document.body.appendChild(tempLink);
    tempLink.click();

    setTimeout(function () {
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }, 200);
  }
}
